import type { ApiErrors } from './api-response.model';

/** Thrown when the API returns a non-success envelope or an HTTP error. */
export class ApiError extends Error {
  override readonly name = 'ApiError';

  constructor(
    message: string,
    readonly errors: ApiErrors = null,
    readonly status?: number,
  ) {
    super(message);
  }
}
